import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "vsense_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);
  const [reserveOpen, setReserveOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const keyOf = (i) => `${i.product_id}__${i.color}__${i.shape || ""}__${i.lens || ""}`;

  const addItem = (item, openDrawer = true) => {
    setItems((prev) => {
      const idx = prev.findIndex((p) => keyOf(p) === keyOf(item));
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], quantity: next[idx].quantity + item.quantity };
        return next;
      }
      return [...prev, item];
    });
    if (openDrawer) setOpen(true);
  };

  const updateQty = (key, qty) => {
    setItems((prev) =>
      prev
        .map((p) => (keyOf(p) === key ? { ...p, quantity: Math.max(1, qty) } : p))
        .filter((p) => p.quantity > 0)
    );
  };

  const removeItem = (key) => setItems((prev) => prev.filter((p) => keyOf(p) !== key));
  const clear = () => setItems([]);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const subtotal = items.reduce((s, i) => s + i.unit_price * i.quantity, 0);

  return (
    <CartContext.Provider
      value={{ items, open, setOpen, reserveOpen, setReserveOpen, addItem, updateQty, removeItem, clear, count, subtotal, keyOf }}
    >
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
